var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card--nofeedback"},[_c('i',{staticClass:"mc-fa icon-fill_wifi-off"}),_c('p',[_vm._v(_vm._s(_vm.$t('trackVideo.deviceUnreachable')))]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.$emit('clickTryAgain')}}},[_vm._v(_vm._s(_vm.$t('global.action.tryAgain')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }